import { constants } from '@tradetrust-tt/token-registry-v4';

const contractAddress = constants.contractAddress;

export { contractAddress };
